import { render, staticRenderFns } from "./testWebsocket.vue?vue&type=template&id=86abb728&"
import script from "./testWebsocket.vue?vue&type=script&lang=js&"
export * from "./testWebsocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports